'use strict';

angular.module('webAgro1App').factory('ItensManutencaoService', function($http, RestService) {
  return {
    list: function(filters) {
      filters = filters || {};
      filters.no_paginate = true;

      var url = SERVER + API_VERSION + 'itens_manutencao';
      return $http.get(url, {params: filters});
    },

    listPaginated: function(filters) {
      var params = !filters ? {} : {
        page: filters.page || null
      };
      var url = SERVER + API_VERSION + 'itens_manutencao';
      return RestService.getFromUrl(url, params);
    }
  };
});
